export const LOGIN_ADMIN = 'LOGIN_ADMIN';
export const LOGOUT_ADMIN = 'LOGOUT_ADMIN';
export const PROFILE_ADMIN = 'PROFILE_ADMIN';
export const UPDATE_ADMIN_PROFILE = 'UPDATE_ADMIN_PROFILE';